import { render } from "./ModifierSetModifierTable.vue?vue&type=template&id=3ad7b3f7"
import script from "./ModifierSetModifierTable.vue?vue&type=script&lang=js"
export * from "./ModifierSetModifierTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__